import React from 'react'
import Header_Bus from '../LayoutMain_Bus/Header_Bus'

export default function DashboardMain_Bus(props) {
  return (
    <>
      <Header_Bus />
      {props.children}
    </>
  )
}
